export class CambioDolarCompra {

    static path = 'cambio_dolar_compra/';

    valor: Float32Array;

    constructor() {
    }
  }



// WEBPACK FOOTER //
// ./src/app/configuracion/cambioDolarCompra.model.ts